import { styled } from "@mui/system";
import Button from "@mui/material/Button";

/**
 * Dialog container styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledDialogContainer = styled("div")(({ theme }) => ({
  backgroundColor: "rgba(0,0,0,.3)"
}));

/**
 * Dialog paper styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledDialogPaper = styled("div")(({ theme }) => ({
  width: "650px",
  borderRadius: "8px",
  boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
  backgroundColor: "#ffffff",
  "@media (max-width: 420px)": {
    overflow: "hidden",
    margin: "0 15px"
  }
}));

/**
 * Dialog title styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledDialogTitle = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "30px 40px 10px 40px",
  "& > h2": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: "normal"
  }
}));

/**
 * Dialog content styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledDialogContent = styled("div")(({ theme }) => ({
  padding: "8px 40px"
}));

/**
 * Dialog actions styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledDialogActions = styled("div")(({ theme }) => ({
  padding: "20px",
  justifyContent: "center",
  "@media (max-width: 372px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
}));

/**
 * Button spacing styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledButtonSpacing = styled("div")(({ theme }) => ({
  "& > * + *": {
    marginLeft: "20px"
  }
}));

/**
 * Action button styling
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledActionButton = styled(Button)(({ theme }) => ({
  width: "200px",
  height: "42px",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "normal",
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

/**
 * Margin top styling for mobile view
 * @type {import('@mui/system').StyledComponent}
 */
export const StyledMarginTop = styled("div")(({ theme }) => ({
  "@media (max-width: 372px)": {
    marginTop: "12px",
    marginLeft: 0
  }
}));
